"use strict";
class SettingsService {
    constructor($rootScope, persistenceService) {
        this.rootScope = $rootScope;
        this.persistenceService = persistenceService;
        //this.getClient = wtcpjsClientProviderService.getClient;
    }

    persistVolume(percentScale) {
        this.persistenceService.setUserProfileServerValue('volume', { percentScale });
    }

    set shareLocation (value) {
        this.persistenceService.setUserProfileServerValue('shareLocation', value);
        this.rootScope.$broadcast('settingsService.shareLocation', value);
    }

    get shareLocation () {
        // Default
        let shareLoc = this.persistenceService.getUserProfileServerValue('shareLocation');
        if (typeof shareLoc !== "boolean") 
            return this.shareLocation = true;
        else
            return shareLoc;
    }

    set location (value) {
        this.persistenceService.setUserProfileServerValue('location', value);
    }

    get location () {
        return this.persistenceService.getUserProfileServerValue('location');
    }

    getVolume() {
        let val = this.persistenceService.getUserProfileServerValue('volume');
        if (val)
            return val.percentScale;
        else
            return 100;
    }

    updateChannelSelection(channels) {
        this.persistenceService.setUserProfileServerValue('channels', channels);
    }

    getChannelSelection() {
        return this.persistenceService.getUserProfileServerValue('channels') || {};
    }
}

angular.module('webcomm').service('settingsService', ['$rootScope', 'persistenceService', SettingsService]);